import React, { useContext, useEffect, useState } from "react";
import { Container, Card, Table, Badge, Button, Modal } from "react-bootstrap";
import "../../../assets/css/user/customerorder/customerorder.css";
import Navbar from "../../../components/user/navbar/Navbar";
import SimpleBanner from "../general/SimpleBanner";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";

const CustomerOrders = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // const fetchCustomerOrders = () => {

  //   setLoading(true);
  //   const savedCustomer = JSON.parse(localStorage.getItem("loggedInUser"));
  //   const formData = new FormData();
  //   formData.append("tpcustomer_id", savedCustomer.id);

  //   axios
  //     .post(`${baseUrl}/customer/orders/fetchCustomerOrders`, formData, {
  //       headers: { "Content-Type": "multipart/formData" },
  //     })
  //     .then((res) => {
  //       console.log("Orders Response:", res.data);

  //       if (res.data.success === true) {
  //         setOrders(res.data.orders);
  //       }

  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // };
  const fetchCustomerOrders = () => {
    setLoading(true);
    const savedCustomer = JSON.parse(localStorage.getItem("loggedInUser"));
    const formData = new FormData();
    formData.append("tpcustomer_id", savedCustomer.id);

    axios
      .post(`${baseUrl}/customer/orders/fetchCustomerOrders`, formData)
      .then((res) => {
        if (res.data.success === true) {
          setOrders(res.data.orders);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    console.log(orders);
    fetchCustomerOrders();
  }, []);
  const getStatusBadge = (status) => {
  switch (status) {
    case "ongoing":
      return <Badge bg="" className="status-badge ongoing">Ongoing</Badge>;

    case "complete":   // ✅ already sahi hai
      return <Badge bg="" className="status-badge completed">Completed</Badge>;

    case "pending":    // ✅ naya add karein
      return <Badge bg="" className="status-badge ongoing">Pending</Badge>;

    case "cancelled":
      return <Badge bg="" className="status-badge cancelled">Cancelled</Badge>;

    default:
      return null;
  }
};

  return (
    <Container fluid className="py-4">
      <MarqueeBanner />
      <Navbar />

      <SimpleBanner
        title="Orders"
        subtitle=""
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "orders", href: "/customer-orders" },
        ]}
      />
      <Card className="orders-card shadow-sm border-0">
        <Card.Body>
          <h4 className="fw-bold mb-4">My Orders</h4>

          <div className="table-responsive">
            <Table hover className="align-middle mb-0">
              <thead>
                <tr>
                  <th>Order ID</th>
                  {/* <th>Deal</th> */}
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      Loading orders...
                    </td>
                  </tr>
                ) : orders.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No orders found
                    </td>
                  </tr>
                ) : (
                  orders.map((order) => (
                    <tr key={order.id}>
                      <td className="fw-semibold">{order.id}</td>

                      {/* <td style={{ minWidth: "220px" }}> */}
                      {/* <div className="d-flex flex-wrap gap-2"> */}
                      {/* {order?.tpdeal?.map((deal, index) => (
                            <span key={index} className="deal-tag">
                              {deal.deal_title}
                            </span>
                          ))} */}
                      {/* {order.tpcart?.tpdeal?.deal_title}
                        </div> */}
                      {/* </td> */}

                      <td className="fw-semibold">
                        PKR {order.amount?.toLocaleString()}
                      </td>

                      <td>
                        {new Date(order.created_at).toLocaleDateString("en-GB")}
                      </td>

                      <td>{getStatusBadge(order.status)}</td>

                      <td>
                        <div className="d-flex flex-wrap gap-2">
                          {order.status === "complete" && (
                            <Button
                              size="sm"
                              variant={
                                order.rated ? "success" : "outline-secondary"
                              }
                              onClick={() => {
                                console.log(order);

                                navigate(
                                  `/rate/${order.tpshop_id}/${order.id}`,
                                );
                              }}
                            >
                              ⭐ {order.rated ? "Rated" : "Rate"}
                            </Button>
                          )}

                          <Button
                            size="sm"
                            variant="primary"
                            onClick={
                              () =>
                                navigate("/order-detail", { state: { order } })
                              //   {
                              //   console.log(order);
                              //   setSelectedOrder(order);
                              //   setShowModal(true);
                              // }
                            }
                          >
                            👁 View
                          </Button>

                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => {
                              console.log("Sending Order:", order);

                              navigate("/support-disputes", {
                                state: {
                                  order: order,
                                },
                              });
                            }}
                          >
                            ⚠ Dispute
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Order Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedOrder && (
            <>
              <p>
                <strong>Order ID:</strong> {selectedOrder.id}
              </p>
              <p>
                <strong>Amount:</strong> PKR{" "}
                {selectedOrder.amount?.toLocaleString()}
              </p>
              <p>
                <strong>Status:</strong> {selectedOrder.status}
              </p>
              <p>
                <strong>Date:</strong>{" "}
                {new Date(selectedOrder.created_at).toLocaleDateString("en-GB")}
              </p>

              {/* ✅ Deals list */}
              <hr />
              <p>
                <strong>Deals:</strong>
              </p>
              {selectedOrder?.tpcarts?.length > 0 ? (
                <Table size="sm" bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Deal Title</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.tpcarts.map((cart, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{cart?.tpdeal?.deal_title}</td>
                        <td>PKR {cart?.tpdeal?.deal_price}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-muted">No deals found</p>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Footer />
    </Container>
  );
};

export default CustomerOrders;
